<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header">
    <div class="modal-title h4">{{'endSession.title' | translate}}</div>
 
    <button aria-label="Close" data-dismiss="modal" class="close" type="button" (click)="logout()">
        <span aria-hidden="true">{{'main.charX' | translate}}</span>
    </button>
</div>
<div class="modal-body">
    <div class="row text-center">
        <div class="col-md-12">
            {{'endSession.message' | translate : { value: counter$ | async } }}
        </div>
    </div>
</div>
<div class="modal-footer justify-content-start border-0 pt-0">
    <button type="submit" class="btn btn-primary btn-lg px-5" (click)="subscribeForNextSessionExpiration()">
        {{'endSession.btnExtendSession' | translate}}</button>
    <button type="button" class="btn btn-link" (click)="logout()">{{'endSession.btnClose' | translate}}</button>
</div>